(function PurchasedLeads($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady() {
		$(".confirm-delete").on('click', function confirmMessage(e) {
			var default_msg = $(this).data('confirm-msg') || "Are you sure you want to delete this record?";
			return confirm(default_msg);
		});
	});

}(jQuery, window.Adzuki || {}));